<aside class="sidebar" [class.open]="sidebarService.isOpen()" *ngIf="!sidebarCollapsed" role="navigation" aria-label="Menú principal">
  <!-- Mobile overlay backdrop -->
  <div class="sidebar-backdrop" *ngIf="sidebarService.isOpen()" (click)="toggleCollapse()" aria-hidden="true"></div>

  <div class="sidebar-top">
    <div class="top-actions">
      <button class="top-card top-card--notif" matRipple matTooltip="Notificaciones" aria-label="Notificaciones"
        (click)="toggleNotifications()">
        <div class="top-card-icon" [matBadge]="notificationCount()" [matBadgeHidden]="notificationCount() === 0" matBadgeColor="warn" matBadgeSize="small">
          <i class="bi bi-bell"></i>
        </div>
      </button>

      <button class="top-card top-card--collapse" matRipple matTooltip="Ocultar menú" aria-label="Ocultar menú"
        (click)="toggleCollapse()">
        <div class="top-card-icon">
          <i class="bi bi-chevron-left"></i>
        </div>
      </button>
    </div>

    <div class="user-summary" [matMenuTriggerFor]="userMenu" role="button" aria-label="Abrir menú de usuario" matRipple>
      <button class="user-summary-logout" (click)="onLogout(); $event.stopPropagation()" matRipple matTooltip="Cerrar sesión"
        aria-label="Cerrar sesión">
        <i class="bi bi-vinyl-fill"></i>
      </button>
      <div class="user-avatar">{{ userInitial() }}</div>
      <div class="user-details">
        <strong>{{ userName() }}</strong>
        <span class="user-center">{{ sportCenterName() }}</span>
        <span class="user-role badge-gold" *ngIf="isMainManager()">Administrador Principal</span>
      </div>
    </div>
  </div>

  <div class="sidebar-content" role="region" aria-label="Navegación">
    <mat-nav-list class="nav-list">
      @for (item of sidebarService.menuItems(); track item.id) {
      <a mat-list-item class="nav-item-link" [routerLink]="item.route" routerLinkActive="active" 
        (click)="onMenuItemClick()"
        [attr.aria-current]="{'page': true}">
        <div class="nav-item-content">
          <span class="icon-shape"><i class="bi {{ item.icon }} sidebar-icon"></i></span>
          <span class="nav-label">{{ item.label }}</span>
        </div>
      </a>
      }
    </mat-nav-list>
  </div>

  <div class="brand-summary">
    <div class="brand-icon">
      <i class="bi bi-pentagon-fill"></i>
    </div>
    <div class="brand-text">
      <strong>CanchasYa</strong>
      <span>Admin dashboard</span>
    </div>
  </div>
</aside>

<button class="collapsed-toggle" *ngIf="sidebarCollapsed" (click)="toggleCollapse()" matRipple matTooltip="Mostrar menú" aria-label="Mostrar menú"
  [matBadge]="notificationCount()" [matBadgeHidden]="notificationCount() === 0" matBadgeColor="warn">
  <i class="bi bi-list"></i>
  <span class="collapsed-label">Mostrar menú</span>
</button>

<!-- User Menu utilizing Angular Material Menu -->
<mat-menu #userMenu="matMenu" class="custom-user-menu" xPosition="after">
  <a mat-menu-item routerLink="/settings">
    <i class="bi bi-person-circle menu-item-icon"></i>
    <span>Mi perfil</span>
  </a>
  <a mat-menu-item routerLink="/settings">
    <i class="bi bi-gear menu-item-icon"></i>
    <span>Configuración</span>
  </a>
  <mat-divider></mat-divider>
  <button mat-menu-item class="menu-item--warn" (click)="onLogout()">
    <i class="bi bi-box-arrow-right menu-item-icon"></i>
    <span>Cerrar sesión</span>
  </button>
</mat-menu>

<app-notifications-drawer [isOpen]="openNotifications" (closeDrawer)="toggleNotifications()"></app-notifications-drawer>